import { mainApi } from "services/main";
import {
  CreateAssessmentRequest,
  CreateAssessmentResponse,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    createAssessment: builder.mutation<
      CreateAssessmentResponse,
      CreateAssessmentRequest
    >({
      query: (request: CreateAssessmentRequest) => ({
        url: "assessment",
        body: request,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useCreateAssessmentMutation } = extendedApi;
